<template>
  Powered by
  <a href="https://www.iceberg-digital.co.uk/neuron/home" class="n-link" target="_blank"><b>Neuron</b></a>
  |
  <a href="https://www.iceberg-digital.co.uk/" class="n-link" target="_blank"> <b>Iceberg Digital</b></a>
</template>
<script lang="ts"></script>
